/**
 * Account settings menu config. Used by SettingsMenu in `'account'` nav
 * mode.
 *
 * Hierarchy:
 *
 *   ACCESS      Admin users · Roles
 *   ADMIN       Account · Integrations · Calendar feeds · Exports ·
 *               Local cache · Security & legal
 *
 * Admin users + Roles were carved out of the Manage "Team" group when we
 * split the settings menu — they're account/permission concerns, distinct
 * from the bookable-Employees roster which stays under Manage.
 *
 * All settings routes in this menu live under `/account/*`.
 */
export const groups = [
  {
    label: '',
    items: [
      {
        label: 'components.account.pages.usersAndRoles.label',
        icon: 'lucide:user-cog',
        path: '/account/team/users',
        info: 'components.account.pages.usersAndRoles.info',
        children: [
          {
            label: 'manage.landings.team.adminUsersLabel',
            icon: 'lucide:user-cog',
            path: '/account/team/users',
          },
          {
            label: 'account.roles',
            icon: 'lucide:shield-check',
            path: '/account/team/roles',
          },
        ],
      },
      {
        label: 'components.account.pages.planAndBilling.label',
        icon: 'lucide:credit-card',
        path: '/account/account',
        info: 'components.account.pages.planAndBilling.info',
      },
      {
        label: 'components.account.pages.security.label',
        icon: 'lucide:shield',
        path: '/account/security-and-legal/security',
        info: 'components.account.pages.security.info',
      },
      { label: 'components.account.pages.cachedData.label', icon: 'lucide:hard-drive', info: 'components.account.pages.cachedData.info', path: '/account/local-cache' },
      { label: 'components.account.pages.integrations.label', icon: 'lucide:puzzle', info: 'components.account.pages.integrations.info', path: '/account/integrations' },
      { label: 'components.account.pages.sessions.label', icon: 'lucide:monitor-smartphone', info: 'components.account.pages.sessions.info', path: '/account/security-and-legal/sessions' },
      { label: 'components.account.pages.calendarFeeds.label', icon: 'lucide:calendar', info: 'components.account.pages.calendarFeeds.info', path: '/account/calendar-feeds' },
      { label: 'components.account.pages.policy.label', icon: 'lucide:file-text', info: 'components.account.pages.policy.info', path: '/account/security-and-legal/policy' },
      { label: 'components.account.pages.exports.label', icon: 'lucide:download', info: 'components.account.pages.exports.info', path: '/account/exports' },
    ],
  },
]
